import { render, staticRenderFns } from "./generalInterpretation.vue?vue&type=template&id=4a0e38d0&scoped=true&"
import script from "./generalInterpretation.vue?vue&type=script&lang=js&"
export * from "./generalInterpretation.vue?vue&type=script&lang=js&"
import style0 from "./generalInterpretation.vue?vue&type=style&index=0&id=4a0e38d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0e38d0",
  null
  
)

export default component.exports